import React from 'react';
import PropTypes from 'prop-types';

import './Animate.scss';

const AnimateStarIcon = ({ loadingInfinite, loadingFinite }) => {
  const renderStarAnimation = () => {
    return (
      <rect id="StarAnimateFill" className="loading-finite" height="20px" width="20px" fill="#ffffff" />
    );
  };

  return (
    <svg className="star-icon" width="18px" height="17px" viewBox="0 0 18 17" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <desc>Star Icon</desc>
      <defs />
      <g id="Hierarchy-Selector-Prototype" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        {loadingInfinite ?
          <rect id="StarAnimateFill" className="loading-infinite" height="20px" width="20px" fill="#ffffff" /> : ''
        }
        {loadingFinite ? renderStarAnimation() : ''}
      </g>
    </svg>
  );
};

AnimateStarIcon.propTypes = {
  loadingInfinite: PropTypes.bool,
  loadingFinite: PropTypes.bool,
};

AnimateStarIcon.defaultProps = {
  loadingInfinite: false,
  loadingFinite: false,
};

export default AnimateStarIcon;
